import { useState } from "react";
import Modal from "react-modal";
import { useParams } from "react-router-dom";
import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "../toast";

Modal.setAppElement("#root");
const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		padding: "2rem",
		borderRadius: "10px",

		width: "80%",
		maxWidth: "700px",
		maxHeight: "650px",
		zIndex: 1000,
	},
};

const AddNewBehaviouralQuestion = ({
	getQuestions,
}: {
	getQuestions: () => void;
}) => {
	const toast = useToast();
	const { setLoading } = useLoader();
	const [modalIsOpen, setIsOpen] = useState(false);
	const { id } = useParams();
	const [newQuestion, setNewQuestion] = useState("");

	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}
	const addNewQuestion = async () => {
		try {
			setLoading(true);
			const response = await api.post("add_new_question", {
				data: { b_question_text: newQuestion },
				job_id: id,
				section: "behavioral",
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Question Added",
					title: "New question have been added successfully",
					description: "",
					open: true,
				});
				getQuestions();
				closeModal();
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: "Error Adding new question",
				description: error.response?.data?.error || error.response?.data?.message || "",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	return (
		<div className="">
			<button
				onClick={openModal}
				className="flex gap-2 items-center bg-[#BDE4C3] text-[#438437] text-sm   p-2.5 rounded-md shadow-md hover:scale-110 transition"
			>
				Add New Question
			</button>
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={closeModal}
					style={customStyles}
					contentLabel="Example Modal"
				>
					<div>
						<h2 className="font-heading my-3 text-xl">
							Add New Behavioural Question
						</h2>
						<textarea
							id="question"
							className="border border-gray-300 rounded px-2 py-1 w-full"
							rows={5}
							value={newQuestion}
							onChange={(e) => setNewQuestion(e.target.value)}
						></textarea>
						<div className="mt-6 flex justify-end space-x-3">
							<button
								onClick={addNewQuestion}
								className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded"
							>
								Add
							</button>
							<button
								onClick={closeModal}
								className="px-4 py-2 text-[#438437] border-1 rounded-md hover:bg-gray-300 transition"
							>
								Cancel
							</button>
						</div>
					</div>
				</Modal>
			)}
		</div>
	);
};

export default AddNewBehaviouralQuestion;
